// ABOUTME: Tab bar for switching between config views (Products, Categories, Defaults, Shops).
// ABOUTME: Controls which config level view is active on the configuration page.

import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useTranslation } from 'react-i18next';
import { colors } from '../../theme/colors';

export default function LevelNavigationTabs({ activeTab, onTabChange }) {
  const { t } = useTranslation();

  return (
    <Tabs
      value={activeTab}
      onChange={(_, newValue) => onTabChange(newValue)}
      sx={{
        borderBottom: `2px solid ${colors.border.light}`,
        mb: 2,
        '& .MuiTab-root': {
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.875rem',
          minWidth: 'auto',
          px: 3,
        },
        '& .Mui-selected': {
          color: `${colors.ui.button} !important`,
        },
        '& .MuiTabs-indicator': {
          backgroundColor: colors.palette.orange,
        },
      }}
    >
      <Tab value="products" label={t('config.tabs.products')} />
      <Tab value="categories" label={t('config.tabs.categories')} />
      <Tab value="defaults" label={t('config.tabs.defaults')} />
      <Tab value="shops" label={t('config.tabs.shops')} />
    </Tabs>
  );
}
